module.exports = __webpack_public_path__ + "img/pets_403.3fd47685.svg";